import log from 'salvo-lite/log'
import rivets from 'rivets'
import { format } from 'money-formatter'

class RecentlyViewed {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._rivetsTemplate = this._elem.querySelector('[data-recently-viewed-template]')
        this._product = this._elem.hasAttribute('data-product') ? JSON.parse(this._elem.dataset.product) : false
        this._settings = this._elem.dataset.settings ? JSON.parse(this._elem.dataset.settings) : {}
        this._settings = Object.assign({
            currency: 'GBP',
            initialise: true,
            limit: 16
        }, this._settings)
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        if (this._settings.initialise) {
            this.init()
        }
    }

    init () {
        log.debug(this.constructor.name, 'Initiating')

        if (this._product) this.addProductToLocalStorage()
        this.pruneRecentlyViewed()
        this.rivetsBindings()
        this.renderRecentlyViewed()

        log.debug(this.constructor.name, 'Initiated')
    }

    rivetsBindings () {
        rivets.binders['background'] = (el, value) => {
            el.style.setProperty('background-image', `url('${value}')`)
        }

        rivets.formatters['money'] = (value) => {
            return format(this._settings.currency, parseFloat(value / 100))
        }

        rivets.formatters['getUrl'] = (value) => {
            return '/products/' + value
        }
    }

    renderRecentlyViewed () {
        let recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewed'))
        for (let i = 0; i < recentlyViewedProducts.length; i++) {
            if (recentlyViewedProducts[i].id === this._product.id) {
                recentlyViewedProducts.splice(i, 1)
            }
        }
        rivets.bind(this._rivetsTemplate, { products: recentlyViewedProducts })
        if (recentlyViewedProducts.length === 0) {
            this._elem.classList.add('hide')
        }
        this._elem.dispatchEvent(new Event('rendered'))
    }

    pruneRecentlyViewed () {
        let currentProducts = localStorage.getItem('recentlyViewed') ? JSON.parse(localStorage.getItem('recentlyViewed')) : []

        if (currentProducts.length > this._settings.limit) {
            let difference = currentProducts.length - this._settings.limit
            currentProducts.splice(difference)
        }

        localStorage.setItem('recentlyViewed', JSON.stringify(currentProducts))
    }

    addProductToLocalStorage () {
        let currentProducts = localStorage.getItem('recentlyViewed') ? JSON.parse(localStorage.getItem('recentlyViewed')) : []
        let hasBeenAdded = false
        for (let product of currentProducts) {
            if (product.id === this._product.id) {
                hasBeenAdded = true
            }
        }
        if (!hasBeenAdded) currentProducts.unshift(this._product)
        localStorage.setItem('recentlyViewed', JSON.stringify(currentProducts))
    }
}

export default RecentlyViewed



// WEBPACK FOOTER //
// ./src/scripts/components/RecentlyViewed.js